import { render, staticRenderFns } from "./InlineNavigation.vue?vue&type=template&id=8dbb55c2&scoped=true&"
import script from "./InlineNavigation.vue?vue&type=script&lang=js&"
export * from "./InlineNavigation.vue?vue&type=script&lang=js&"
import style0 from "./InlineNavigation.vue?vue&type=style&index=0&id=8dbb55c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dbb55c2",
  null
  
)

export default component.exports